function triggerLinkOsso(ssoID) {
  let userAccessToken = JSON.parse(sessionStorage.getItem('currentUser'));
  let curLanguageCode = JSON.parse(localStorage.getItem('SelectedLanguage'));
  let currentCulture = curLanguageCode.cultureCode;
  let stateData = "";
  let tPRequestItem = [];
  sendOSSOForm(ssoID, userAccessToken.access_token, currentCulture, stateData, tPRequestItem);
}

function sendOSSOForm(id, acessToken, culture = 'en-us', stateData = null, tPRequestItem = []) {
  let clientSsoId = id;
  let takeOverBrowser = false;
  if (id) {
    let idArr = id.split('|');
    if (idArr.length > 1) {
      clientSsoId = idArr[0];
      takeOverBrowser = (idArr[1] == 'True');
    }
  }
  const OssoViewModel = {
    culture: culture,
    stateData: stateData,
    TPRequestItem: tPRequestItem,
    ssoID: clientSsoId,
    userToken: acessToken,
    employee_EventRecordID: ''
  };
  const url = '/SSO/OSSOInner?SSOID=' + clientSsoId;
  const stateModel = JSON.stringify(OssoViewModel);
  const form = document.createElement('form');
  form.setAttribute('method', 'post');
  form.setAttribute('action', url);
  if (sessionStorage.getItem('IsFromMobileApp') == 'true') {
    takeOverBrowser = true;
  }
  if (takeOverBrowser) {
    form.setAttribute('target', '_self');
  }
  else {
    form.setAttribute('target', 'OutboundExchange');
  }
  let el = document.createElement('input');
  el.setAttribute('type', 'hidden');
  el.setAttribute('name', 'ssoModelData');
  el.setAttribute('value', stateModel);
  form.append(el);
  document.querySelector('#ssoFormContainer').append(form);
  if (!takeOverBrowser) {
    window.open(
      '',
      'OutboundExchange',
      'height=600,width=1000,top=0,left=0,toolbar=no,menubar=no,scrollbars=yes, resizable=yes,location=no, status=no'
    );
  }
  form.submit();
  form.remove();
}

function jwtDecodeToken(token) {
  const parts = token.split('.');
  if (parts.length !== 3) {
    throw new Error('JWT must have 3 parts');
  }
  const decoded = jwtUrlBase64Decode(parts[1]);
  if (!decoded) {
    throw new Error('Cannot decode the token');
  }
  return JSON.parse(decoded);
}

function jwtUrlBase64Decode(str) {
  let output = str.replace(/-/g, '+').replace(/_/g, '/');
  switch (output.length % 4) {
    case 0: {
      break;
    }
    case 2: {
      output += '==';
      break;
    }
    case 3: {
      output += '=';
      break;
    }
    default: {
      throw 'Illegal base64url string!';
    }
  }
  return decodeURIComponent(escape(window.atob(output)));
}

////////////////////////////////////////////////////////////// Below comes from origial aon-customize-googleanalytics.js, we merge together for performance things////////////////////////////////


function gtag() {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push(arguments);
}

function setDefaultStorage() {
  let ad_storage_default = analytics_storage_default = 'denied';
  if (window.OnetrustActiveGroups.indexOf('6') != -1) {
    analytics_storage_default = 'granted';
  }

  if (window.OnetrustActiveGroups.indexOf('C0004') != -1) {
    ad_storage_default = 'granted';
  }

  gtag('consent', 'default', {
    ad_storage: ad_storage_default,
    analytics_storage: analytics_storage_default,
  });

  setDefaultStorage = function () { };
}

function listenToConsentChanges() {
  if (window.OnetrustActiveGroups) {
    window.dataLayer = window.dataLayer || [];
    setDefaultStorage();
  }

  OneTrust.OnConsentChanged && OneTrust.OnConsentChanged(function (event) {
    let ad_storage = 'denied', analytics_storage = 'denied';

    if (event.detail.indexOf('6') != -1) {
      analytics_storage = 'granted';
    }

    if (event.detail.indexOf('C0004') != -1) {
      ad_storage = 'granted';
    }

    gtag('consent', 'update', {
      ad_storage: ad_storage,
      analytics_storage: analytics_storage,
    });
  });
}


////////////////////////////////////////////////////////////// Below are section download important file////////////////////////////////

function getOktaAuthHeader() {
  const headers = {};
  try {
    const stored = sessionStorage.getItem('oktaToken');
    if (stored) {
      const parsed = JSON.parse(stored);
      const tokenType = typeof parsed?.token_type === 'string' ? parsed.token_type.trim() : '';
      const accessToken = typeof parsed?.access_token === 'string' ? parsed.access_token.trim() : '';
      if (tokenType && accessToken) {
        headers['okta_Token'] = `${tokenType} ${accessToken}`;
      }
    }
  } catch (e) { }
  try {
    const subscriptionKey = window.BootstrapRequestContext && window.BootstrapRequestContext().ocpApimSubscriptionKey;
    if (subscriptionKey) {
      headers['Ocp-Apim-Subscription-Key'] = subscriptionKey;
    }
  } catch (e) {  }
  return headers;
}
async function getSecureFile(fileName, path = "/Secured-Documents") {
  if (isFromAndroidApp()) {
    getSecureFileFromAndroid(fileName, path);
  } else {
    getSecureFileFromNonAndriod(fileName, path);
  }
}

async function getSecureFileInline(fileName, path = "/Secured-Documents") {
  if (isFromAndroidApp()) {
    getSecureFileFromAndroid(fileName, path, true);
  } else {
    getSecureFileInlineFromNonAndroid(fileName, path);
  }
}

async function getGroupComn(recordID) {
  if (isFromAndroidApp()) {
    getGroupComnFromAndroid(recordID);
  } else {
    getGroupComnFromNonAndriod(recordID);
  }
}

async function getSecureFileFromAndroid(fileName, path, isInline = false) {
  const baseUrl = window.BootstrapRequestContext().apiBaseUrl; 
  let curLanguageCode = JSON.parse(localStorage.getItem('SelectedLanguage'));
  let culture = curLanguageCode.cultureCode
  let siteName = window.BootstrapRequestContext().siteName;
  const url = `${baseUrl}${culture}/${siteName}/secureFile?path=${encodeURIComponent(path)}&fileName=${encodeURIComponent(fileName)}`;
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${currentUser.access_token}`,
               TimeZoneOffSet: new Date().getTimezoneOffset().toString(),
              'Accept-Language': curLanguageCode == null ? 'en-US' : curLanguageCode.cultureCode,
              ...getOktaAuthHeader()
            }
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

      const data = await response.json();
      if (isInline) {
        openFileByBase64InNewTab(data);
      } else {
        downLoadFileByBase64(data);
      }
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
    }
}

async function getGroupComnFromAndroid(recordID) {
  const curLanguageCode = JSON.parse(localStorage.getItem('SelectedLanguage') || 'null');
  const model = buildGroupComnDownloadModel(recordID);

  const rawBase = (window.BootstrapRequestContext && window.BootstrapRequestContext().apiBaseUrl) ? window.BootstrapRequestContext().apiBaseUrl : '';
  const baseApi = rawBase.replace(/\/+$/g, '');
  const url = `${baseApi}/GroupComn`;

  const currentUser = JSON.parse(sessionStorage.getItem('currentUser') || 'null');

  try {
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': currentUser?.access_token ? `Bearer ${currentUser.access_token}` : '',
        'Accept-Language': curLanguageCode == null ? 'en-US' : curLanguageCode.cultureCode,
        TimeZoneOffSet: new Date().getTimezoneOffset().toString(),
        ...getOktaAuthHeader()
      },
      body: JSON.stringify(model || [])
    });

    if (!resp.ok) {
      const errText = await resp.text().catch(() => '');
      throw new Error(`GroupComn POST failed: ${resp.status} ${resp.statusText} ${errText}`);
    }

    const data = await resp.json(); 
    downLoadFileByBase64(data);
  } catch (err) {
    console.error('getGroupComnFromAndroid error:', err);
  }
}

async function getSecureFileFromNonAndriod(fileName, path) {
  let curLanguageCode = JSON.parse(localStorage.getItem('SelectedLanguage'));
  let culture = curLanguageCode.cultureCode
  let siteName = window.BootstrapRequestContext().siteName;
  let downloadModel = { path: path, fileName: fileName, culture: culture, siteName: siteName };

  downloadFile('/Download/SecureFile', downloadModel);
}

async function getSecureFileInlineFromNonAndroid(fileName, path) {
  let curLanguageCode = JSON.parse(localStorage.getItem('SelectedLanguage'));
  let culture = curLanguageCode.cultureCode
  let siteName = window.BootstrapRequestContext().siteName;
  let downloadModel = { path: path, fileName: fileName, culture: culture, siteName: siteName };

  downloadFile('/Download/SecureFileInline', downloadModel, 'post', '_blank');
}

async function getGroupComnFromNonAndriod(recordID) {
  const model = buildGroupComnDownloadModel(recordID);
  downloadFile('/Download/GroupComn', model);
}

function openFileByBase64InNewTab(response) {
  const byteChars = atob(response.base64);
  const bytes = new Uint8Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) {
    bytes[i] = byteChars.charCodeAt(i);
  }
  const blob = new Blob([bytes], { type: response.document_MIMEType });
  const url = URL.createObjectURL(blob);
  if (sessionStorage.getItem("IsFromMobileApp") == 'true') {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

function downLoadFileByBase64(response){
  const filename = response.document_File_Name;
  const downloadLink = document.createElement('a');
  downloadLink.href = `data:${response.document_MIMEType};headers=Content-Disposition: attachment; filename=${filename};base64,${response.base64}`;
  downloadLink.setAttribute('download', filename);
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}
// Usage example
//* sends a request to the specified url from a form. this will change the window location.
// * @param {string} path the path to send the post request to
//* @param {object} params the parameters to add to the url
//* @param {string} [method=post] the method to use on the form

function downloadFile(path, formparam, method = 'post', target = '') {

  const userAccessToken = JSON.parse(sessionStorage.getItem('currentUser'));
  formparam.userToken = userAccessToken.access_token;
  const oktaHeader = getOktaAuthHeader();
  if (oktaHeader['okta_Token']) {
    formparam.oktaToken = oktaHeader['okta_Token'];
  }
  const formvalue = JSON.stringify(formparam);
  const params = { downloadModelData: formvalue };
  // The rest of this code assumes you are not using a library.
  // It can be made less verbose if you use one.
  const form = document.createElement('form');
  form.method = method;
  form.action = path;
  for (const key in params) {
    if (Object.hasOwn(params, key)) {
      const hiddenField = document.createElement('input');
      hiddenField.type = 'hidden';
      hiddenField.name = key;
      hiddenField.value = params[key];
      form.appendChild(hiddenField);
    }
  }
  if (target) {
    form.setAttribute('target', target);
  } else if (sessionStorage.getItem("IsFromMobileApp") == 'true') {
    form.setAttribute('target', '_self');
  }

  document.body.appendChild(form);
  form.submit();
  form.remove();
}

function isFromAndroidApp() {
  return sessionStorage.getItem("IsFromAndroidApp") == 'true';
}
  // --- Helpers used by the GroupComn flows ---

  function getActForEmployeeID() {
    try {
      if (typeof SessionStorageKey !== 'undefined' && SessionStorageKey && SessionStorageKey.ActDelegateEmployee) {
        return sessionStorage.getItem(SessionStorageKey.ActDelegateEmployee);
      }
    } catch (e) { /* ignore */ }
    // fallback literal key
    return sessionStorage.getItem('ActDelegateEmployee');
  }

  function getUIConfiguration() {
    try {
      const perRole = sessionStorage.getItem('uiConfigPerRole');
      if (perRole) {
        return JSON.parse(perRole);
      }
      const guest = sessionStorage.getItem('uiConfigGuest');
      if (guest) {
        return JSON.parse(guest);
      }
    } catch (err) {
      console.warn('getUIConfiguration: failed to parse UI config from sessionStorage', err);
    }
    return null;
  }

  // Build request key/value array helper (ParamType: Key/Value)
  function objectToKeyValueArray(obj) {
    const result = [];
    if (!obj || typeof obj !== 'object') return result;
    for (const k in obj) {
      if (!Object.hasOwn(obj, k)) continue;
      let v = obj[k];
      if (v === null || v === undefined || v === '') continue;
      if (typeof v === 'object') {
        try {
          v = JSON.stringify(v);
        } catch (e) {
          continue;
        }
      }
      // ParamType on server expects Key/Value (capitalized)
      result.push({ Key: k, Value: String(v) });
    }
    return result;
  }

  function uiConfigGroupCommJsonResult(uiConfig) {
    const cfg = (uiConfig && uiConfig.uiConfiguration) ? uiConfig.uiConfiguration : {};
    return {
      OverrideCurrencySetting: (cfg.overrideCurrencySetting === true ? "1" : "0"),
      CurrencySymbol: (cfg.customCurrencySymbol || "") !== "" ? cfg.customCurrencySymbol : "",
      CurrencyFormat: (cfg.currencyFormat || "") !== "" ? cfg.currencyFormat : "",
      CurrencySymbolWithSpace: (cfg.currencySymbolWithSpace === true ? "1" : "0"),
      CurrencySymbolPosition: (cfg.currencySymbolPosition || "") !== "" ? cfg.currencySymbolPosition : "",
      CurrencyFormatOverride: (cfg.currencyFormatOverride || "") !== "" ? cfg.currencyFormatOverride : "",
      CurrencyFormatOverrideByResourceString: (cfg.currencyFormatOverrideByResourceString === true ? "1" : "0"),
    };
  }

  function buildGroupComnDownloadModel(recordID) {  
    const request = [];
    const uiConfig = getUIConfiguration();
    if (uiConfig) {
      const uiJson = uiConfigGroupCommJsonResult(uiConfig);
      const uiKVs = objectToKeyValueArray(uiJson);
      request.push(...uiKVs);
    }
    const model = {
      RecordID: recordID,
      ParamTypes: request,
      ActForEmployeeID : getActForEmployeeID()
    };
    return model;
  }
   
////////////////////////////////////////////////////////////// End Download important file////////////////////////////////

function triggerOIDCAuthorize() {
  // 1. Get user access token and culture code
  const userAccessToken = JSON.parse(sessionStorage.getItem('currentUser'));
  const curLanguageCode = JSON.parse(localStorage.getItem('SelectedLanguage'));
  const currentCulture = curLanguageCode.cultureCode;

  // 2. Setup API URL
  const endpointPath = '/SSO/OIDCAuthorize';
  
  // 3. Make a fetch request
  fetch(endpointPath, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${userAccessToken.access_token}`,
      'Accept-Language': currentCulture
    }
  })
  .then(response => {
    // Always parse JSON
    return response.json().then(data => ({
      status: response.status,
      ok: response.ok,
      data: data
    }));
  })
  .then(result => {
    if (!result.ok) {
      throw new Error(`Network response was not ok. Status: ${result.status}`);
    }
    if (result.data && result.data.redirectUrl) {
      // Perform the redirect
      window.location.href = result.data.redirectUrl;
    } else {
      console.log('Response data:', result.data);
    }
  })
  .catch(error => {
    console.error('There was a problem with the fetch operation:', error);
  });
}
